module.exports = __webpack_public_path__ + "static/media/icon_google-bigquery.5a775c4f.svg";